import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {HoldStatus} from '@store/holds/holds.types';

@Component({
  selector: 'px-hold-position',
  template: `
    @if (status === 'REQUESTED') {
      @if (forHoldsTable) {
        <div class="flex flex-col justify-start items-center w-full">
          <p class="text-title-medium">#{{ queueIndex }}</p>
          <p class="text-body-small">on {{ copiesCount }} {{ +copiesCount === 1 ? 'copy' : 'copies' }}</p>
        </div>
      } @else {
        <span>#{{ queueIndex }} on {{ copiesCount }} {{ +copiesCount === 1 ? 'copy' : 'copies' }}</span>
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HoldPositionComponent {

  @Input({required: true}) status: HoldStatus;
  @Input({required: true}) queueIndex: string;
  @Input({required: true}) copiesCount: string | number;
  @Input() forHoldsTable: boolean = false;
}
